<template>
    <mdb-container fluid>    
        <mdb-row class="justify-content-md-center">
           <mdb-col lg="10" text-center>
            <mdb-col md="4" > 
                <mdb-card class="login-box">
                <mdb-card-body>
                   <!-- Material form login 
                <form>-->
                <p class="h4 text-center mb-4">Sign in</p>
                <div class="grey-text">
                <mdb-input label="Company Code" icon="envelope" type="text" v-model="user"/>
                <mdb-input label="Your password" icon="lock" type="password" v-model="pass"/>
                
                </div>
                <div class="text-center">
                <mdb-btn v-on:click="validateLogin" class="btn-login">Login</mdb-btn>
                </div>
                <div class="text-center">
                    <mdb-badge pill color="orange" :v-if="err" >{{err}}</mdb-badge>
                </div>
               <!-- </form>
             Material form login -->
                </mdb-card-body>
                </mdb-card>
            </mdb-col>
           </mdb-col>
      
        </mdb-row>
  </mdb-container>
     

</template>

<script>
import axios from 'axios';
import { mdbRow, mdbContainer, mdbCol, mdbInput, mdbBtn,mdbCard, mdbCardBody,mdbBadge  } from 'mdbvue';
export default {
    name: 'Body',
    data(){
        return{user:'', 
        pass:'',message:'',err:''}
    },
    components:{
        mdbContainer,
        mdbRow,
        mdbCol,mdbInput, mdbBtn,mdbCard, mdbCardBody, mdbBadge 
    },
   
    methods:{
        
        validateLogin:function(){
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
            const formData = new FormData()
            formData.append('username', this.user)
            formData.append('password', this.pass)
            //alert('frmdata'+formData)
           
            axios.post(this.$store.state.apiUrl+'/login',formData,config)
            .then(response => {
                response = response.data[0]
                if(response === undefined || response.length == 0 ){
                    //console.log('invalid')
                    this.err='! Invalid Credential / No Access'
                }
                else{
                    this.$store.state.companyData['custom_text_1'] = response.custom_text_1
                    this.$store.state.companyData['custom_text_2'] = response.custom_text_2
                    this.$store.state.companyData['custom_text_3'] = response.custom_text_3
                    this.$store.state.companyData['custom_text_4'] = response.custom_text_4
                    this.$store.state.companyData['custom_text_5'] = response.custom_text_5
                    this.$store.state.companyData['id_company'] = response.id_company
                    this.$store.state.companyData['id_design'] = response.id_design
                    this.$store.state.companyData['id_eap'] = response.id_eap
                    this.$store.state.companyData['id_service'] = response.id_service
                    this.$store.state.companyData['name_company'] = response.name_company
                    this.$store.state.companyData['name_css'] = response.name_css
                    this.$store.state.companyData['id_language'] = response.language_id_default.substr(3,3)
                    //this.$store.state.companyData['id_language'] = '003'
                    this.$store.state.companyData['id_country'] = response.language_id_default.substr(0,3)
                    localStorage.id_company = response.id_company;
                    localStorage.id_design = response.id_design;
                    localStorage.id_eap = response.id_eap;
                    localStorage.id_service = response.id_service;
                    localStorage.id_language = response.language_id_default.substr(3,3);
                    //localStorage.id_language = '003'
                    localStorage.id_country = response.language_id_default.substr(0,3);
                    localStorage.custom_text_1 = response.custom_text_1;
                    //console.log('w-',this.$store.state.companyData )
                    this.$store.dispatch('getTheme');
                    this.$store.dispatch('getLanguageTerms');
                    this.$store.dispatch('getThemeLogic');
                    this.$router.push({path:'/'})
                }
                
            })
            .catch(() => {
                this.company_data = [];
                this.err='Try after sometime'
            });
            event.preventDefault();
        }
    }
 
};
</script>
<style scoped>
.login-box{
    margin-top: 55px;    
    padding: 10px;
}
.btn-login{background-color: #6b6b6b91;}
.badge{
    font-size: 85%;
}
</style>
